import { render, staticRenderFns } from "./product-detail-fee.vue?vue&type=template&id=9ecc1222&functional=true&"
import script from "./product-detail-fee.vue?vue&type=script&lang=js&"
export * from "./product-detail-fee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports